import React from 'react'
import ProfileDelete from 'src/app/ProfileDelete/ProfileDelete'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { profileDeleteRouteProps } from 'src/navigation/routeProps'

const ProfileDeleteAppRoute: AppRoute = {
  id: AppLocation.ProfileDelete,
  routeProps: profileDeleteRouteProps,
  component: <ProfileDelete />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ProfileDeleteAppRoute
